import * as types from '../mutation-types'
const state = {
	companyValues: []
}

const actions = {
	fetchCompanyValues ({ commit }) {
		return window.axios.get('/company-values').then((response) => {
			commit(types.STORE_COMPANY_VALUES, response.data)
			return response.data
		})
	}
}

const mutations = {
	[types.STORE_COMPANY_VALUES] (state, companyValues) {
		state.companyValues = companyValues;
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}